// extracted by mini-css-extract-plugin
module.exports = {"titleFav":"instutions_titleFav__3TOZ3","Fav":"instutions_Fav__Z1_qF"};